import React from "react";
import RRLogo from "../../../assets/roofing-reports-assets/r-logo-1.svg";
import RRQRCode from "../../../assets/roofing-reports-assets/rr-qrcode.svg";
import LocationWhite from "../../../assets/roofing-reports-assets/location-white.svg";
import LocationGrey from "../../../assets/roofing-reports-assets/location.svg";
import PhoneGrey from "../../../assets/roofing-reports-assets/phone-icon.svg";

import "./styles.scss";

const Page1 = ({ address, background }) => {
  return (
    <div className=" py-2 shadow">
      <div className="p1-logo-container">
        <img src={RRLogo} />
      </div>
      <div
        style={{
          background: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
        className="p1-main-content"
      >
        <div className="p1-main-content__title">
          <h4 className="p1-main-content__title-h4">
            Remote Roofing <br /> Drone Assessment Report
          </h4>
          <div className="p1-main-content__title-address-container">
            <img src={LocationWhite} />
            <span> {address} </span>
          </div>
        </div>
        <img className="p1-main-content__image" src={RRQRCode} />
      </div>
      <div className="p1-bottom-content">
        <div className="p1-bottom-content-website">
          <h6> CONTACT INFORMATION</h6>
          <a href="https://remoteroofing.com"> www.remoteroofing.com </a>
        </div>
        <div className="p1-bottom-content-address">
          <div className="phoneNumber">
            {" "}
            <img src={PhoneGrey} /> <span> (800) 401-7716</span>{" "}
          </div>
          <div className="address">
            {" "}
            <img src={LocationGrey} /> <span> 7460 Warren Pkwy Suite 100</span>{" "}
            <img style={{ visibility: "hidden" }} src={LocationGrey} />{" "}
            <span> Frisco TX 75034</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page1;
